import React from "react";
import { IonAvatar, IonIcon, IonItem, IonLabel, IonNote, IonText, isPlatform } from "@ionic/react";
import {
  bookmarkOutline,
  calendarOutline,
  documentTextOutline,
  personOutline,
} from "ionicons/icons";
import { Document } from "../../../@types/document";
import { DocumentStatusTag } from "../../../components/Document/DocumentStatusTag";

interface ItemListProps {
  document: Document;
}

export const DocumentItemList: React.FC<ItemListProps> = ({ document }) => {
  const { title, createdAt, author } = document;
  return (
    <IonItem
      routerLink={`/app/rrhh/acuerdos/${document.id}`}
      lines="none"
      class="ion-margin-bottom"
    >
      {isPlatform("desktop") && (
        <IonAvatar slot="start">
          <IonIcon icon={documentTextOutline} size="large" />
        </IonAvatar>
      )}
      <IonLabel>
        <h2 style={{ fontWeight: 500 }} className="ion-text-wrap">
          {title}
        </h2>
        <h4>
          <IonIcon icon={personOutline}></IonIcon>
          <IonText class="ion-padding-start">{author?.name}</IonText>
        </h4>
        <p>
          <IonIcon icon={calendarOutline}></IonIcon>
          <IonText class="ion-padding-start">{createdAt}</IonText>

          <IonIcon icon={bookmarkOutline} class="ion-padding-start" />
          <IonText class="ion-padding-start">{`${document.category?.name}`}</IonText>
        </p>
      </IonLabel>

      <IonNote slot="end">
        <DocumentStatusTag document={document} />
      </IonNote>
    </IonItem>
  );
};
